// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TPJZ","title":"styles_title__2sYqd"};